export const formatterNum = (num, bit) => {
    /* 
     * 格式化数据方法
     * @num { number } 需要格式化的数据
     * @bit { number } 保留的小数位数
     * @return { stringNumber } 
     */
    if (num == '--' || num == '-') return '--'
    return (num * 1).toFixed(bit)
}

export const formatterMoney = (num, bit) => {
    /* 
     * 格式化数据方法
     * @num { number } 需要格式化的数据
     * @bit { number } 保留的小数位数
     * @return { string } 
     */
    if (num == '--' || num == '-') return '--'
    let _bit = bit || 0
    if ((num / 1e8) >= 1 || (num / 1e8) <= -1) {
        return (num / 1e8).toFixed(_bit) + '亿'
    } else if ((num / 1e4) >= 1 || (num / 1e4) <= -1) {
        return (num / 1e4).toFixed(_bit) + '万'
    } else {
        return (num * 1).toFixed(_bit)
    }
}

export const formatUnit = (num, unit) => {
    /* 
     * 配合formatterMoney 进行NaN去除以及 添加数据单位
     */
    if (num == 'NaN' || num == '--' || num == '-') return '--'
    return num + unit
}